import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa'; // For feature lists

// Placeholder pricing data - customize this for LiveFunnel
const pricingPlans = [
  {
    name: 'Starter',
    price: '$49',
    billingCycle: '/mo',
    description: 'Perfect for individuals and small dealerships getting started.',
    features: ['5 Funnels', '1,000 Leads/mo', 'Basic Analytics', 'Email Support'],
    ctaText: 'Choose Starter',
    ctaLink: '/signup?plan=starter',
    highlight: false,
  },
  {
    name: 'Growth',
    price: '$99',
    billingCycle: '/mo',
    description: 'For growing dealerships looking to scale their lead generation.',
    features: [
      '20 Funnels',
      '5,000 Leads/mo',
      'Advanced Analytics',
      'Priority Email Support',
      'Basic Integrations',
    ],
    ctaText: 'Choose Growth',
    ctaLink: '/signup?plan=growth',
    highlight: true, // To make this plan stand out
  },
  {
    name: 'Pro',
    price: '$199',
    billingCycle: '/mo',
    description: 'Comprehensive features for large operations and agencies.',
    features: [
      'Unlimited Funnels',
      '20,000 Leads/mo',
      'Full Analytics Suite',
      'Dedicated Phone Support',
      'Premium Integrations',
      'Team Accounts (3 Users)',
    ],
    ctaText: 'Choose Pro',
    ctaLink: '/signup?plan=pro',
    highlight: false,
  },
];

const PricingPage = () => {
  return (
    <div className="bg-gray-50 py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Find the LiveFunnel Plan That's Right for You
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Start your 14-day free trial today. No credit card required. Cancel anytime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-lg p-6 md:p-8 flex flex-col ${
                plan.highlight
                  ? 'border-4 border-primary ring-4 ring-primary-light'
                  : 'border border-gray-200'
              }`}
            >
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">{plan.name}</h2>
              <p className="text-gray-500 mb-4 h-16">{plan.description}</p>{' '}
              {/* Fixed height for description alignment */}
              <div className="mb-6">
                <span className="text-4xl font-extrabold text-gray-900">{plan.price}</span>
                <span className="text-lg font-medium text-gray-500">{plan.billingCycle}</span>
              </div>
              <ul className="space-y-3 mb-8 flex-grow">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start">
                    <FaCheckCircle className="text-green-500 w-5 h-5 mr-2 mt-1 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={plan.ctaLink}
                className={`w-full block text-center py-3 px-6 rounded-lg font-semibold transition-colors duration-300
                  ${
                    plan.highlight
                      ? 'bg-primary text-white hover:bg-primary-dark'
                      : 'bg-gray-100 text-primary hover:bg-gray-200 border border-gray-300'
                  }`}
              >
                {plan.ctaText}
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">Need something more?</h3>
          <p className="text-lg text-gray-600 mb-6 max-w-xl mx-auto">
            For enterprise solutions, high-volume needs, or custom requirements, contact us for a
            personalized plan.
          </p>
          <Link
            to="/contact"
            className="bg-secondary text-white hover:bg-secondary-dark py-3 px-8 text-lg font-semibold rounded-lg transition-colors duration-300"
          >
            Contact Sales
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
